import React from 'react';
import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import { appRoutes } from '@/routes/constants';

type GoBackTextProps = {
    value: string;
    externalLink?: string;
    onClick?: () => void;
};

const GoBackText = ({
    value,
    externalLink,
    onClick,
}: GoBackTextProps): JSX.Element => {
    return !externalLink && !onClick ? (
        <Link
            style={{
                display: 'block',
                width: 'fit-content',
                textDecoration: 'none',
                color: 'unset',
            }}
            to={appRoutes.HOME}
            reloadDocument
        >
            <Typography variant="body2" color="secondary">
                {value}
            </Typography>
        </Link>
    ) : (
        <a
            style={{
                display: 'block',
                width: 'fit-content',
                textDecoration: 'none',
                color: 'unset',
                cursor: 'pointer',
            }}
            rel="noopener noreferrer"
            href={!onClick ? `${externalLink}` : undefined}
            onClick={onClick}
        >
            <Typography variant="body2" color="secondary">
                {value}
            </Typography>
        </a>
    );
};

export default GoBackText;
